import { useGetAllStatesAndTerritoriesQuery } from '@/services/ApiService.ts';

export const useStatesAndTerritories = () => {
    const { data, isFetching, isLoading, isError } = useGetAllStatesAndTerritoriesQuery();

    return {
        states: data || [],
        isFetching,
        // First load only — callers that must wait for the lookup table (CMS visibility)
        // need to distinguish it from a background refetch.
        isLoading,
        isError,
    };
};
